import Cookies from 'js-cookie'
import { mapActions, mapState, mapMutations } from 'vuex'

export const userMixin = {
	computed: {
		...mapState('user', [ 'userData' ]),
		cvAccountToken () {
			let _t = Cookies.get('_t') || Cookies.get('_t_plugin')
			if (_t) {
				let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
				return tokenPayload.User.c_t
			}
		}
	},
	methods: {
		...mapActions('user', [ 'getUserAccountInfo' ]),
		...mapMutations('user', [ 'changeUserData' ]),
		async getUserData () {
			await this.getUserAccountInfo(this.cvAccountToken)
		}
	}
}
